<template>
    <span>
        <editarpost></editarpost>
    </span>
</template>

<script>
import Editarpost from '@/components/Editar-Post';

export default {
    name: 'cadeditarpost',
    components: {
        Editarpost
    }
};
</script>